import type { ValueOf } from '@skin-seoul/utils';

export const WoocommercePaymentMethod = {
  Bacs: 'bacs',
  Cod: 'cod',
  Paypal: 'paypal',
  Stripe: 'stripe',
  Cheque: 'cheque',
  Klarna: 'klarna',
  Square: 'square',
  Razorpay: 'razorpay',
  Mollie: 'mollie',
  WoocommercePayments: 'woocommerce_payments',
} as const;

export type WoocommercePaymentMethodValue = ValueOf<typeof WoocommercePaymentMethod>;

export enum ShippingMethodId {
  FlatRate = 'flat_rate',
  FreeShipping = 'free_shipping',
  LocalPickup = 'local_pickup',
  LocalDelivery = 'local_delivery',
  LegacyFlatRate = 'legacy_flat_rate',
  LegacyFreeShipping = 'legacy_free_shipping',
  LegacyInternationalDelivery = 'legacy_international_delivery',
  LegacyLocalDelivery = 'legacy_local_delivery',
}
